import { useQuery } from '@tanstack/react-query';

import { TourFormDeparture, getTourFormDepartures } from '~/services/ToursService';

export const tourDepartureQueryKeys = {
  all: ['tour-departures'] as const,
  list: (tourId: string | undefined) => [...tourDepartureQueryKeys.all, tourId ?? ''] as const,
};

/**
 * Every departure the tour runs, past and upcoming.
 *
 * Only the named ones are returned: a by-departure cost price is keyed by the
 * departure's name, so one without a name cannot be priced.
 */
export function useGetTourDepartures(tourId: string | undefined) {
  return useQuery({
    queryKey: tourDepartureQueryKeys.list(tourId),
    queryFn: async ({ signal }): Promise<Array<TourFormDeparture>> => {
      const departures = await getTourFormDepartures(tourId, { signal });

      return departures.filter((departure) => !!departure.departureName);
    },
    enabled: !!tourId,
  });
}
